import React, { useState } from 'react';

const content = {
  en: {
    toggleLabel: '中文',
    title: 'Vessel – Support',
    subtitle: 'A quiet vessel for your everyday moods.',
    disclaimer:
      'Vessel is a personal mood-journaling application built for self-reflection and personal growth — a quiet space to get to know yourself a little better. Everyone experiences highs and lows, and recording how you feel does not mean you are unwell or have a mental-health condition. If you are experiencing emotional or psychological difficulties, please consult a licensed mental-health professional. Vessel is not a medical device and is not a substitute for professional medical advice, diagnosis, or treatment.',
    aboutTitle: 'About the App',
    aboutBody:
      'Vessel is a personal mood-journaling iOS application built for self-reflection and personal growth. It is frontend-only — there are no servers, no accounts, and no remote backends operated by us. All of your entries (mood scores, notes, sketches, voice memos, and short videos) are stored locally on your device and never leave it.',
    contactTitle: 'Contact',
    contactBody1Pre: 'For support requests, feedback, or bug reports, please email:',
    contactEmail: 'flowintothewall@gmail.com',
    contactBody2:
      'We aim to respond within a few business days. Please include your iOS version and a short description of the issue when reporting a bug.',
    faqTitle: 'Frequently Asked Questions',
    faqs: [
      {
        q: 'Where is my data stored?',
        a: "Entirely on your device, inside iOS's standard application sandbox. Vessel does not upload, sync, or back up your data to any server we operate.",
      },
      {
        q: 'How do I back up my entries?',
        aBold: 'Vessel includes an in-app Backup button.',
        aRest:
          " When tapped, it exports your data as a JSON-formatted snapshot file stored on your device. This is a frontend-only local backup and does not guarantee against data loss. You should manage the backup file yourself (for example, copy it to your own iCloud Drive or computer). For additional safety, also rely on your device's standard backup mechanisms (encrypted iCloud Backup or encrypted Finder/iTunes backup).",
      },
      {
        q: 'How do I delete my data?',
        a: "You can delete individual entries from inside the app, reset all app data via the app's settings, or simply uninstall the app from your device, which removes all stored data.",
      },
      {
        q: 'Is Vessel a medical or therapeutic tool?',
        a: 'No. Vessel is intended for personal reflection and self-understanding only, and is not a substitute for professional medical, psychological, or psychiatric advice. If you are experiencing emotional distress or a mental-health crisis, please contact a licensed mental-health professional, your local emergency services, or a recognized crisis hotline.',
      },
    ],
    policiesTitle: 'Policies',
    privacyLabel: 'Privacy Policy:',
    privacyUrl: 'https://www.bewater-funghokkeung.com/vessel-privacy',
    termsLabel: 'Terms of Service:',
    termsUrl: 'https://www.bewater-funghokkeung.com/vessel-terms',
    footer: 'Document effective as of the date of last revision.',
  },
  zh: {
    toggleLabel: 'EN',
    title: 'Vessel – 支援',
    subtitle: '一個安靜地承托日常心情的容器。',
    disclaimer:
      'Vessel 是一個個人心情紀錄應用程式，旨在協助你進行自我反思與個人成長 —— 一個安靜的空間，讓你更認識自己。每個人都會有情緒的高低起伏，紀錄心情並不代表你有病或心理出問題。如你正面對情緒或精神上的困擾，請務必諮詢持牌的精神健康專業人士。Vessel 並非醫療裝置，亦不能取代任何專業醫療建議、診斷或治療。',
    aboutTitle: '關於應用程式',
    aboutBody:
      'Vessel 是一個個人心情紀錄 iOS 應用程式，旨在協助使用者進行自我反思與個人成長。它是純前端的應用程式 —— 我們沒有伺服器、沒有帳戶系統、亦沒有由我們營運的後端。你的所有紀錄（心情分數、筆記、塗鴉、語音備忘和短片）都儲存在你的裝置上，並永不離開你的裝置。',
    contactTitle: '聯絡',
    contactBody1Pre: '如需支援、提供意見或回報問題，請電郵至：',
    contactEmail: 'flowintothewall@gmail.com',
    contactBody2:
      '我們會盡量於數個工作日內回覆。回報錯誤時，請附上你的 iOS 版本及簡短的問題描述。',
    faqTitle: '常見問題',
    faqs: [
      {
        q: '我的資料儲存在哪裡？',
        a: '完全儲存於你的裝置上，置於 iOS 標準應用程式沙盒內。Vessel 不會將你的資料上傳、同步或備份到任何由我們營運的伺服器。',
      },
      {
        q: '我要怎樣備份我的紀錄？',
        aBold: 'Vessel 應用程式內建「備份」按鈕。',
        aRest:
          '點擊後，應用程式會將你的資料以 JSON 格式匯出為一個快照檔，並儲存於你的裝置上。這只是一個純前端的本機備份功能，並不保證資料不會遺失。你應該自行妥善管理該備份檔（例如自行複製到你的 iCloud Drive 或電腦）。為更妥善保存，建議同時使用 iOS 系統的標準備份機制（例如已加密的 iCloud 備份或已加密的 Finder/iTunes 備份）。',
      },
      {
        q: '我要怎樣刪除我的資料？',
        a: '你可以在應用程式內刪除個別紀錄、透過應用程式設定重設所有資料，或直接從裝置解除安裝應用程式 —— 解除安裝後，所有已儲存資料皆會一併移除。',
      },
      {
        q: 'Vessel 是醫療或治療工具嗎？',
        a: '不是。Vessel 僅供個人反思與自我認識之用，並不能取代任何專業醫療、心理或精神科建議。如你正經歷情緒困擾或精神健康危機，請聯絡持牌的精神健康專業人士、當地緊急服務或認可的危機支援熱線。',
      },
    ],
    policiesTitle: '政策連結',
    privacyLabel: '私隱政策：',
    privacyUrl: 'https://www.bewater-funghokkeung.com/vessel-privacy',
    termsLabel: '服務條款：',
    termsUrl: 'https://www.bewater-funghokkeung.com/vessel-terms',
    footer: '本文件以最新修訂日期為生效日期。',
  },
};

export default function VesselSupport() {
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'en';
    return localStorage.getItem('vesselDocLang') === 'zh' ? 'zh' : 'en';
  });
  const t = content[lang];

  const toggleLang = () => {
    const next = lang === 'en' ? 'zh' : 'en';
    setLang(next);
    if (typeof window !== 'undefined') {
      localStorage.setItem('vesselDocLang', next);
    }
  };

  const styles = {
    page: {
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      fontFamily: 'Times, "Times New Roman", serif',
      color: '#000000',
      margin: 0,
      padding: 0,
    },
    container: {
      maxWidth: '8.5in',
      margin: '0 auto',
      padding: '1in',
      lineHeight: '1.5',
      fontSize: '12pt',
    },
    langToggle: {
      position: 'fixed',
      top: '20px',
      right: '24px',
      background: '#ffffff',
      border: '1.5px solid #000',
      padding: '6px 14px',
      fontFamily: 'Times, "Times New Roman", serif',
      fontSize: '11pt',
      cursor: 'pointer',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      color: '#000',
      zIndex: 100,
      boxShadow: '2px 2px 0 #000',
    },
    header: {
      textAlign: 'center',
      marginBottom: '30px',
      borderBottom: '2px solid #000',
      paddingBottom: '20px',
    },
    title: {
      fontSize: '18pt',
      fontWeight: 'bold',
      margin: '0 0 10px 0',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    subtitle: {
      fontSize: '14pt',
      fontWeight: 'normal',
      margin: '0',
      fontStyle: 'italic',
    },
    disclaimer: {
      margin: '0 0 30px 0',
      padding: '18px 22px',
      border: '1.5px solid #000',
      backgroundColor: '#fafafa',
    },
    disclaimerText: {
      margin: 0,
      fontSize: '11.5pt',
      lineHeight: '1.6',
      textAlign: 'justify',
      fontWeight: 'bold',
    },
    section: {
      marginBottom: '25px',
      pageBreakInside: 'avoid',
    },
    sectionNumber: {
      fontSize: '14pt',
      fontWeight: 'bold',
      marginBottom: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    paragraph: {
      fontSize: '12pt',
      marginBottom: '12px',
      textAlign: 'justify',
      textIndent: lang === 'zh' ? '0' : '0.5in',
      lineHeight: '1.5',
    },
    paragraphNoIndent: {
      fontSize: '12pt',
      marginBottom: '12px',
      textAlign: 'justify',
      lineHeight: '1.5',
    },
    footer: {
      marginTop: '40px',
      paddingTop: '20px',
      borderTop: '1px solid #000',
      textAlign: 'center',
      fontSize: '10pt',
      color: '#666',
    },
  };

  return (
    <div style={styles.page} lang={lang === 'zh' ? 'zh-Hant' : 'en'}>
      <button
        type="button"
        onClick={toggleLang}
        style={styles.langToggle}
        aria-label={lang === 'en' ? 'Switch to Chinese' : 'Switch to English'}
      >
        {t.toggleLabel}
      </button>

      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>{t.title}</h1>
          <p style={styles.subtitle}>{t.subtitle}</p>
        </div>

        <div style={styles.disclaimer}>
          <p style={styles.disclaimerText}>{t.disclaimer}</p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>{t.aboutTitle}</h2>
          <p style={styles.paragraph}>{t.aboutBody}</p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>{t.contactTitle}</h2>
          <p style={styles.paragraphNoIndent}>
            {t.contactBody1Pre} <strong>{t.contactEmail}</strong>
          </p>
          <p style={styles.paragraphNoIndent}>{t.contactBody2}</p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>{t.faqTitle}</h2>
          {t.faqs.map((item, i) => (
            <React.Fragment key={i}>
              <p style={styles.paragraphNoIndent}>
                <strong>{item.q}</strong>
              </p>
              {item.aBold ? (
                <p style={styles.paragraph}>
                  <strong>{item.aBold}</strong>
                  {item.aRest}
                </p>
              ) : (
                <p style={styles.paragraph}>{item.a}</p>
              )}
            </React.Fragment>
          ))}
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>{t.policiesTitle}</h2>
          <p style={styles.paragraphNoIndent}>
            <strong>{t.privacyLabel}</strong> {t.privacyUrl}
          </p>
          <p style={styles.paragraphNoIndent}>
            <strong>{t.termsLabel}</strong> {t.termsUrl}
          </p>
        </div>

        <div style={styles.footer}>
          <p>{t.footer}</p>
        </div>
      </div>
    </div>
  );
}
